var _circle, _path, _ellipse, _ellipse2, _path2, _path3, _path4, _path5, _ellipse3, _ellipse4, _path6, _path7, _path8, _path9, _path10, _path11, _rect, _path12, _path13, _ellipse5, _ellipse6, _rect2, _rect3, _rect4, _rect5, _rect6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPwf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 21,
    fill: "url(#paint0_linear)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M24 45C35.598 45 45 35.598 45 24C45 12.402 35.598 3 24 3V45Z",
    fill: "white"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.2224,
    cy: 10.6362,
    rx: 0.949979,
    ry: 0.954545,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 38.3133,
    cy: 17.3178,
    rx: 0.949979,
    ry: 0.954545,
    fill: "white",
    fillOpacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.56281 10.6367C9.56281 12.4357 8.36924 12.8854 7.77246 12.8854C8.66763 12.8854 9.56281 14.5344 9.56281 15.1341C9.56281 14.2346 10.7564 12.8854 11.3532 12.8854C9.92087 12.8854 9.56281 11.3863 9.56281 10.6367Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0628 20.1816C41.0628 21.9806 39.8692 22.4303 39.2725 22.4303C40.7047 22.4303 41.0628 24.0794 41.0628 24.679C41.0628 23.2399 42.2564 22.4303 42.8532 22.4303C41.4209 22.4303 41.0628 20.9312 41.0628 20.1816Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.56281 10.6367C9.56281 12.4357 8.36924 12.8854 7.77246 12.8854C8.66763 12.8854 9.56281 14.5344 9.56281 15.1341C9.56281 14.2346 10.7564 12.8854 11.3532 12.8854C9.92087 12.8854 9.56281 11.3863 9.56281 10.6367Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0628 20.1816C41.0628 21.9806 39.8692 22.4303 39.2725 22.4303C40.7047 22.4303 41.0628 24.0794 41.0628 24.679C41.0628 23.2399 42.2564 22.4303 42.8532 22.4303C41.4209 22.4303 41.0628 20.9312 41.0628 20.1816Z",
    fill: "white"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.99522,
    cy: 9,
    rx: 0.995216,
    ry: 1,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.9952,
    cy: 16,
    rx: 0.995216,
    ry: 1,
    fill: "white",
    fillOpacity: 0.3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13 15C13 13.3431 14.3431 12 16 12H35C36.6569 12 38 13.3431 38 15V39.5C38 39.5 33.6066 44.5 25.5 44.5C19.2642 44.5 13 41.911 13 41.911V15Z",
    fill: "#E7C605"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11 17C11 15.3431 12.3431 14 14 14H32C33.6569 14 35 15.3431 35 17V42C35 42 30.7823 44.7393 23 44.7393C17.0136 44.7393 11 41.1615 11 41.1615V17Z",
    fill: "#414141"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13 17.2393C13 16.687 13.4477 16.2393 14 16.2393H32.0455C32.5977 16.2393 33.0455 16.687 33.0455 17.2393V42.958C33.0455 42.958 29.5 44.876 23 44.876C18 44.876 13 42.1954 13 42.1954V17.2393Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13 29.6034L33.0455 17.1943V23.8762L13 36.2852V29.6034Z",
    fill: "#EBEBEB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M13 39.1483L33.0455 26.7393V29.6029L13 42.012V39.1483Z",
    fill: "#EBEBEB"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7725 16.2393H29.227L28.8252 17.0428C28.4865 17.7203 27.7939 18.1483 27.0364 18.1483H19.9631C19.2055 18.1483 18.513 17.7203 18.1742 17.0428L17.7725 16.2393Z",
    fill: "#414141"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 24.2393,
    width: 2,
    height: 19,
    rx: 1,
    fill: "#A0A0A0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M2.47656 27.2393C2.47656 26.687 2.92428 26.2393 3.47656 26.2393H23V40.5574H3.47656C2.92428 40.5574 2.47656 40.1097 2.47656 39.5574V27.2393Z",
    fill: "#5497D7"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4545 26.2393H23V40.5574H3.43182C2.99054 40.5574 2.81148 39.9894 3.17299 39.7363L22.4545 26.2393Z",
    fill: "#3C81C8"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.0565,
    cy: 29.0056,
    rx: 1.19319,
    ry: 1.13895,
    fill: "#F09B3B"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.6932,
    cy: 29.0056,
    rx: 1.19319,
    ry: 1.13895,
    fill: "#E85B36"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6.52246,
    y: 36.2393,
    width: 11,
    height: 1,
    fill: "#336DA8"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 6.52246,
    y: 34.2393,
    width: 2,
    height: 1,
    fill: "#336DA8"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 9.52246,
    y: 34.2393,
    width: 2,
    height: 1,
    fill: "#336DA8"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 12.5225,
    y: 34.2393,
    width: 2,
    height: 1,
    fill: "#336DA8"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 15.5225,
    y: 34.2393,
    width: 2,
    height: 1,
    fill: "#336DA8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 42.7297,
    y1: 1,
    x2: 27.8886,
    y2: 49.2825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEEA72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEED6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPwf);
export default __webpack_public_path__ + "static/media/pwf.4d44ccd8.svg";
export { ForwardRef as ReactComponent };